import { PHASE_STATUS } from "admin/phases/_models/PhasesMdl";
import i18next from "i18next";
import dayjs from "dayjs";
import { TPhase } from "properties/_models/PropertyMdl";
import { PointTuple } from "leaflet";

export function getLabelOfPhase(phase?: TPhase) {
    if (!phase) return i18next.t("propertyPage.inventory.phaseLabel.ready");
    switch (phase?.status) {
        case PHASE_STATUS.READY_TO_MOVE_IN:
            return i18next.t("propertyPage.inventory.phaseLabel.ready");
        case PHASE_STATUS.UNDER_CONSTRUCTION:
            return dayjs(phase.deliveryDate).locale(i18next.language).format("MMMM YYYY");
        case PHASE_STATUS.AVAILABLE_X_MONTHS_AFTER:
            return i18next.t("propertyPage.AVAILABLE_X_MONTHS_AFTER_TEXT", { monthsNumber: phase.monthsNumber });
        case PHASE_STATUS.AVAILABLE_X_MONTHS_AFTER_LOT:
            return i18next.t("propertyPage.AVAILABLE_X_MONTHS_AFTER_LOT_TEXT", { monthsNumber: phase.monthsNumber });
        default:
            return i18next.t("propertyPage.inventory.phaseLabel.ready");
    }
}

export function getShortLabelOfPhase(phase?: TPhase) {
    if (!phase) return i18next.t("propertyPage.inventory.shortPhaseLabel.ready");
    switch (phase?.status) {
        case PHASE_STATUS.READY_TO_MOVE_IN:
            return i18next.t("propertyPage.inventory.shortPhaseLabel.ready");
        case PHASE_STATUS.UNDER_CONSTRUCTION:
            return dayjs(phase.deliveryDate).locale(i18next.language).format("MMM YY");
        case PHASE_STATUS.AVAILABLE_X_MONTHS_AFTER:
            return i18next.t("propertyPage.inventory.shortPhaseLabel.AVAILABLE_X_MONTHS_AFTER_TEXT", {
                monthsNumber: phase.monthsNumber,
            });
        default:
            return i18next.t("propertyPage.inventory.shortPhaseLabel.ready");
    }
}

export function getSizeFromAvailablePhase(phase?: TPhase): PointTuple {
    if (!phase) return [60, 20];
    switch (phase?.status) {
        case PHASE_STATUS.READY_TO_MOVE_IN:
            return [50, 20];
        case PHASE_STATUS.UNDER_CONSTRUCTION:
            return [70, 20];
        case PHASE_STATUS.AVAILABLE_X_MONTHS_AFTER:
            return [75, 20];
        default:
            return [60, 20];
    }
}
